import { render, staticRenderFns } from "./VircosLab.vue?vue&type=template&id=73b9c34f&scoped=true&"
import script from "./VircosLab.vue?vue&type=script&lang=js&"
export * from "./VircosLab.vue?vue&type=script&lang=js&"
import style0 from "./VircosLab.vue?vue&type=style&index=0&id=73b9c34f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b9c34f",
  null
  
)

export default component.exports